// utils/netlifyImage.js

/**
 * Transforms a regular image URL to a Netlify CDN-optimized URL.
 * @param {string} url - Original image URL
 * @param {number} [width] - Optional width for the image
 * @returns {string} - Transformed Netlify image URL
 */
export const getNetlifyImageUrl = (url, width) => {
  if (!url) return '';
  const baseUrl = `/.netlify/images?url=${encodeURIComponent(url)}`;
  return width ? `${baseUrl}&w=${width}` : baseUrl;
};

/**
 * Generates a srcset for the Netlify Image CDN
 * @param {string} url - Original image URL
 * @param {number[]} widths - Array of widths for srcset
 * @returns {string} - srcset string
 */
export const generateNetlifySrcSet = (url, widths) => widths
    .map((w) => `${getNetlifyImageUrl(url, w)} ${w}w`)
    .join(', ');
